import { Check, Minus } from "lucide-react";

// Small square checkbox used across the filter panels.
export function Checkbox({ checked }: { checked: boolean | "indeterminate" }) {
  return (
    <div
      className={`flex h-[15px] w-[15px] shrink-0 items-center justify-center rounded-[7px] border-[1.5px] transition-[background,transform] duration-100 ${
        checked
          ? "border-[#28543D] bg-[#28543D]"
          : "border-black/30 bg-[#FBF8F1]"
      }`}
    >
      {checked === true && (
        <Check size={10} strokeWidth={4} className="text-white" />
      )}
      {checked === "indeterminate" && (
        <Minus size={10} strokeWidth={4} className="text-white" />
      )}
    </div>
  );
}
